export const getSsoAuthDomain = (): string => {
  const authDomain =
    import.meta.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "auth-staging.caseblink.com";

  return authDomain
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, "")
    .replace(/\/+$/, "");
};

export const buildDeterministicSamlSpEntityId = ({
  authDomain = getSsoAuthDomain(),
  lawFirmId,
  providerId
}: {
  authDomain?: string;
  lawFirmId: string;
  providerId: string;
}): string => {
  const normalizedLawFirmId = String(lawFirmId || "").trim();
  const normalizedProviderId = String(providerId || "").trim();
  const normalizedAuthDomain = String(authDomain || "").trim();

  if (!normalizedLawFirmId || !normalizedProviderId || !normalizedAuthDomain) {
    return "";
  }

  return `https://${normalizedAuthDomain}/saml/sp/${encodeURIComponent(
    normalizedLawFirmId
  )}/${encodeURIComponent(normalizedProviderId)}`;
};
